import './App.css';
import { Routes, Route } from 'react-router-dom';
import PageSeo from './components/seo/PageSeo';
import Main from './components/pages/main/main';
import ServiceCategoryPage from './components/pages/serviceCategory/ServiceCategoryPage';
import OfferPage from './components/pages/offer/offer';
import PrivacyPage from './components/pages/privacy/privacy';
import AgreementPage from './components/pages/agreement/agreement';
import CookiesPage from './components/pages/cookies/cookies';
import { SERVICE_CATEGORY_PATHS } from './config/serviceCategories';

function App() {
  return (
    <div className="App">
      <PageSeo />
      <Routes>
        <Route path="/" element={<Main />} />
        {SERVICE_CATEGORY_PATHS.map((path) => (
          <Route key={path} path={path} element={<ServiceCategoryPage />} />
        ))}
        <Route path="/offer" element={<OfferPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/agreement" element={<AgreementPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
      </Routes>
    </div>
  );
}

export default App;
